
import { device } from '../../common/util'
import * as nativeCalledListener from '../../api/nativeCalledListener'
import * as nativeComponentApi from '../../api/nativeComponentAPI'
import * as nativeApi from '../../api/index'

// 通用业务平台类
class Platform {
  constructor() {
    this.plt = ''
    if (device().isiOS) {
      this.plt = 'ios'
    } else if (device().isAndroid) {
      this.plt = 'android'
    }
  }

  /**
   * 广播
   * @param eventName
   * @param data
   * @returns {Promise<any>}
   */
  broadcast(eventName, data) {
    nativeApi.broadcast(eventName, data)
  }

  /**
  * 监听广播
  * @param bindEventName
  * @param cb
  */
  onBroadcast(bindEventName, cb) {
    nativeApi.onBroadcast(bindEventName, cb)
  }

  // 从 SDK 获取上下文环境数据
  fetchInitData(params = {pageNo: 1, exclude_ids: []}) {
    nativeApi.fetchInitData(params)
  }

  // load 阶段通知 SDK "H5 页面已经 ready", 可以展示(show) 了
  readyToShowAD() {
    nativeApi.readyToShowAD();
  }

  // load 阶段通知 SDK "H5 页面没有 ready"
  failureToShowAD({errMessage, errDetail} = {}) {
    nativeApi.failureToShowAD({errMessage, errDetail})
  }

  onAdShow(cb) {
    nativeApi.onAdShow(cb)
  }

  //由于banner需求sdk端无法给开发者webviewshow回调的bug，临时由h5自己发送dowebviewshow事件来模拟之前sdk发送的webviewshow事件
  //该方法在新的sdk版本中不会使用
  onAdShowTemp(cb) {
    nativeApi.onAdShowTemp(cb)
  }

  /**
  * 向 SDK 询问 1 ~ n 个广告素材下载/解压到本地之后的存储地址 (file: 协议)
  * @param {String} unitId - 广告位 id
  * @param {Object[]} resource - 要获取的资源描述列表
  * @param {Number} resource[].type - 资源的类型（1:视频，2:web素材地址）
  * @param {String} resource[].ref - 下发的文件远程地址 或者其他可以唯一标示本地资源的索引
  * @returns {*|Promise<any>} 资源在本地存储的路径 (file: 协议)
  */
  VideoBridgeGetFileInfo({unitId, resource}) {
    nativeApi.VideoBridgeGetFileInfo({unitId, resource})
  }

  closeAd(unitId) {
    nativeApi.closeAd(unitId)
  }

  // 从 SDK 获取上下文环境数据
  bannerFetchInitData(params = {pageNo: 1, exclude_ids: []}) {
    nativeApi.bannerFetchInitData(params)
  }

  // load 阶段通知 SDK "H5 页面已经 ready", 可以展示(show) 了
  bannerReadyToShowAD() {
    nativeApi.bannerReadyToShowAD()
  }

  // load 阶段通知 SDK "H5 页面没有 ready"
  bannerFailureToShowAD({errMessage, errDetail} = {}) {
    nativeApi.bannerFailureToShowAD({errMessage, errDetail})
  }

  /**
  * js 通知SDK发送用具体UA上报url
  * @param {Object} params
  * @param {Number} params.type campaign.onlyImpressionUrl,
  * @param {String} params.url campaign.impressionUA
  */
  reportUrl(params = {type: 1, url: ''}) {
    nativeApi.reportUrl(params)
  }

  /**
  * js通知SDK 在客户端发出请求,iOS SDK从v5.6.0 Banner版本开始支持，所有广告类型都支持
  *  数组元素:  {"url":"www.mintegral.com", "type":2}
  *  要求SDK 以type类型的uaType来请求改url
  * type 为可选，目前Impression 一定有，其他的不一定有
  */
  reportUrls(params = [{type: 1, url: ''}, {type: 1, url: ''}]) {
    nativeApi.reportUrls(params)
  }

  sendImpressions(params = []) {
    nativeApi.sendImpressions(params)
  }

  // 显示 native 关闭按钮
  showNativeCloseBtn() {
    nativeApi.showNativeCloseBtn()
  }

  // 隐藏 native 关闭按钮
  hideNativeCloseBtn() {
    nativeApi.hideNativeCloseBtn()
  }

  //设置 native 关闭按钮显示状态
  setNativeCloseBtnDisplay(state) {
    nativeApi.setNativeCloseBtnDisplay(state)
  }

  // Banner广告被点击
  bannerClick(params) {
    nativeApi.bannerClick(params)
  }

  //	获取网络状态
  getNetstat(params) {
    nativeApi.getNetstat(params)
  }

  //	网络状态变更时通知
  onNetstatChanged(cb) {
    nativeApi.onNetstatChanged(cb)
  }

  /**
  * 向 SDK 询问 1 ~ n 个广告素材下载/解压到本地之后的存储地址 (file: 协议)
  * @param {String} unitid 广告位 id
  * @param {Number} type //资源的类型（1:视频，2:web素材地址, 4:img）
  * @param {String} ref //下发的文件远程地址 或者其他可以唯一标示本地资源的索引
  * @returns {*|Promise<any>} 资源在本地存储的路径 (file: 协议)
  */
  getVideoPath({unitId, ref}) {
    nativeApi.getVideoPath({unitId, ref})
  }

  //视图展示时通知
  onViewAppeared(cb) {
    nativeApi.onViewAppeared(cb)
  }

  //视图隐藏时通知
  onViewDisappeared(cb) {
    nativeApi.onViewDisappeared(cb)
  }

  /**
   * 开发者更改页面元素样式时触发
   * @param actionHandle | Function
   */
  onNativeSetStyle (actionHandle) {
    nativeCalledListener.onNativeSetStyle(actionHandle)
  }

  /**
  * 开发者更改页面元素样式时触发
  * @param actionHandle | Function
  */
  onNativeSetStyleList (actionHandle) {
    nativeCalledListener.onNativeSetStyleList(actionHandle)
  }

  /**
  * 开发者通知展示关闭按钮时触发
  * @param actionHandle | Function
  */
  onNativeShowCloseButton (actionHandle) {
    nativeCalledListener.onNativeShowCloseButton(actionHandle)
  }

  /**
  * 开发者通知隐藏关闭按钮时触发
  * @param actionHandle | Function
  */
  onNativeHideCloseButton (actionHandle) {
    nativeCalledListener.onNativeHideCloseButton(actionHandle)
  }

  /**
  * 开发者更改音量设置时触发
  * @param actionHandle | Function
  */
  onNativeSetVolume (actionHandle) {
    nativeCalledListener.onNativeSetVolume(actionHandle)
  }

  /**
  * 开发者更改视频播放器播放模式时触发
  * @param actionHandle | Function
  */
  onNativeSetVideoPlayMode (actionHandle) {
    nativeCalledListener.onNativeSetVideoPlayMode(actionHandle)
  }

  /**
   * 创建一个webview组件
   * @param params
   * @returns {*|Promise<any>}
   */
  createWebview (params = {}) {
    nativeComponentApi.createWebview(params)
  }

  /**
  * 创建视频播放组件
  * @param params
  * @returns {*|Promise<any>}
  */
  createPlayerView (params = {}) {
    nativeComponentApi.createPlayerView(params)
  }

  /**
  * 创建StoreKit视图
  * @param params
  * @returns {*|Promise<any>}
  */
  createStoreKitView (params = {}) {
    nativeComponentApi.createStoreKitView(params)
  }

  /**
  * 创建旧的视频播放模板组件
  * @param params
  * @returns {*|Promise<any>}
  */
  createSubPlayTemplateView (params = {}) {
    nativeComponentApi.createSubPlayTemplateView(params)
  }

  /**
  * 创建旧的endcard组件
  * @param params
  * @returns {*|Promise<any>}
  */
  createEndCard (params = {}) {
    nativeComponentApi.createEndCard(params)
  }

  /**
  * 创建OM组件
  * @param params
  * @returns {*|Promise<any>}
  */
  createOM (params = {}) {
    nativeComponentApi.destroyComponent(params)
  }

  /**
  * 销毁组件
  * @param params
  * @returns {*|Promise<any>}
  */
  destroyComponent (params = {}) {
    nativeComponentApi.destroyComponent(params)
  }

  /**
  * action：3，获取视图的信息
  * @param params
  * @returns {*|Promise<any>}
  */
  getComponentOptions (params = {}) {
    nativeComponentApi.getComponentOptions(params)
  }

  /**
  * action：4，设置视图的信息
  * @param params
  * @returns {*|Promise<any>}
  */
  setComponentOptions (params = {}) {
    nativeComponentApi.setComponentOptions(params)
  }

  /**
  * action：5，修改视图frame
  * @param params
  * @returns {*|Promise<any>}
  */
  setViewRect (params = {}) {
    nativeComponentApi.setViewRect(params)
  }

  /**
  * action：6，从父视图移除视图（默认未释放该对象）
  * @param params
  * @returns {*|Promise<any>}
  */
  removeFromSuperView (params = {}) {
    nativeComponentApi.removeFromSuperView(params)
  }

  /**
  * 在当前视图上添加其他视图
  * @param params
  * @returns {*|Promise<any>}
  */
  appendSubView (params = {}) {
    nativeComponentApi.appendSubView(params)
  }

  /**
  * 将当前视图添加到指定视图上
  * @param params
  * @returns {*|Promise<any>}
  */
  appendViewTo (params = {}) {
    nativeComponentApi.appendViewTo(params)
  }

  /**
  * 移动当前视图到父视图的顶部
  * @param params
  * @returns {*|Promise<any>}
  */
  bringViewToFront (params = {}) {
    nativeComponentApi.bringViewToFront(params)
  }

  /**
  * 隐藏视图
  * @param params
  * @returns {*|Promise<any>}
  */
  hideView (params = {}) {
    nativeComponentApi.hideView(params)
  }

  /**
  * 显示视图
  * @param params
  * @returns {*|Promise<any>}
  */
  showView (params = {}) {
    nativeComponentApi.showView(params)
  }

  /**
  * 设置视图的背景颜色
  * @param params
  * @returns {*|Promise<any>}
  */
  setViewBgColor (params = {}) {
    nativeComponentApi.setViewBgColor(params)
  }

  /**
  * 设置视图的透明度
  * @param params
  * @returns {*|Promise<any>}
  */
  setViewAlpha (params = {}) {
    nativeComponentApi.setViewAlpha(params)
  }

  /**
  * 设置视图的缩放
  * @param params
  * @returns {*|Promise<any>}
  */
  setViewScale (params = {}) {
    nativeComponentApi.setViewScale(params)
  }

  /**
  * 将组件(sourceComponent)添加到目标组件(targetComponent)的上面
  * @param sourceComponentId | Number 添加的组件id
  * @param targetComponentId | Number 目标组件id
  * @param rect | Object 相对于父视图的坐标及宽高
  */
  insertAboveTo(params = {}){
    nativeComponentApi.insertAboveTo(params)
  }

  /**
  * 将组件(sourceComponent)添加到目标组件(targetComponent)的下面
  * @param sourceComponentId | Number 添加的组件id
  * @param targetComponentId | Number 目标组件id
  * @param rect | Object 相对于父视图的坐标及宽高
  */
  insertBelowTo(params = {}){
    nativeComponentApi.insertBelowTo(params)
  }

  /**
  * webview加载url
  * @param params
  * @returns {*|Promise<any>}
  */
  webviewLoad (params = {}) {
    nativeComponentApi.webviewLoad(params)
  }

  /**
  * reload
  * @param params
  * @returns {*|Promise<any>}
  */
  webviewReload (params = {}) {
    nativeComponentApi.webviewReload(params)
  }

  /**
  * goback
  * @param params
  * @returns {*|Promise<any>}
  */
  webviewGoBack (params = {}) {
    nativeComponentApi.webviewGoBack(params)
  }

  /**
  * goforward
  * @param params
  * @returns {*|Promise<any>}
  */
  webviewGoForward (params = {}) {
    nativeComponentApi.webviewGoForward(params)
  }

  /**
  * webviewFireEvent
  * @param params
  * @returns {*|Promise<any>}
  */
  webviewFireEvent (params = {}) {
    nativeComponentApi.webviewFireEvent(params)
  }

  /**
  * 原生视频-播放
  * @param params
  * @returns {*|Promise<any>}
  */
  nativeVideoPlay (params = {}) {
    nativeComponentApi.nativeVideoPlay(params)
  }

  /**
  * 原生视频-暂停
  * @param params
  * @returns {*|Promise<any>}
  */
  nativeVideoPause (params = {}) {
    nativeComponentApi.nativeVideoPause(params)
  }

  /**
  * 原生视频-恢复播放
  * @param params
  * @returns {*|Promise<any>}
  */
  nativeVideoResume (params = {}) {
    nativeComponentApi.nativeVideoResume(params)
  }

  /**
  * 原生视频-停止
  * @param params
  * @returns {*|Promise<any>}
  */
  nativeVideoStop (params = {}) {
    nativeComponentApi.nativeVideoStop(params)
  }

  /**
  * 原生视频-设置为静音
  * @param params
  * @returns {*|Promise<any>}
  */
  nativeVideoMute (params = {}) {
    nativeComponentApi.nativeVideoMute(params)
  }
  /**
  * 原生视频-设置为非静音
  * @param params
  * @returns {*|Promise<any>}
  */
  nativeVideoUnmute (params = {}) {
    nativeComponentApi.nativeVideoUnmute(params)
  }

  /**
  * action：205，原生视频-替换视频源
  * @param params
  * @returns {*|Promise<any>}
  */
  nativeVideoReplaceSource (params = {}) {
    nativeComponentApi.nativeVideoReplaceSource(params)
  }

  /**
  * 预加载storeKit
  * @param params
  * @returns {*|Promise<any>}
  */
  preloadStoreKit (params = {}) {
    console.error('未实现抽象方法：preloadStoreKit')
  }

  /**
  * 添加stk到父视图
  * @param params
  * @returns {*|Promise<any>}
  */
  addStoreKitTo (params = {}) {
    console.error('未实现抽象方法：addStoreKitTo')
  }

  /**
  * 预加载SubPlayTemplateView
  * @param params
  * @returns {*|Promise<any>}
  */
  preloadSubPlayTemplateView (params = {}) {
    nativeComponentApi.preloadSubPlayTemplateView(params)
  }

  /**
  * 设置SubPlayTemplateView信息
  * @param params
  * @returns {*|Promise<any>}
  */
  setSubPlayTemplateInfo (params = {}) {
    nativeComponentApi.setSubPlayTemplateInfo(params)
  }

  /**
  * 全屏展示
  * @param params
  * @returns {*|Promise<any>}
  */
  fullScreenShow (componentId, rootWebviewId, rect={top:0,left:0,right:0,bottom:0}) {
    nativeComponentApi.fullScreenShow(componentId, rootWebviewId, rect)
  }

  /**
   * offer被展示，操作设备持久化存放offer展示频次表(RV/IV广告类型)
   * @param params {Object} campaign信息和unitId(安卓独有)
   */
  increaseOfferFrequenceForRvIv(params) {
    nativeApi.increaseOfferFrequenceForRvIv(params)
  }

  /**
   * 为increaseOfferFrequenceForRvIv接口组成要发送的数据
   * @param campaign {Object}
   */
  prepareDataForIncOfferFreRvIv() {
    console.error('未实现抽象方法：prepareDataForIncOfferFreRvIv')
  }
}

export default Platform